
import { getCommonHead } from "@/utils/head"
export default {
  head() {
    return getCommonHead()
  }
}
